module.exports = __webpack_public_path__ + "static/media/motor_assy.70aefec2.gif";